export { default as GoogleAuthButton } from "./google-auth-button.component";